<template>
	<router-view />

	<Footer />
</template>

<script>
import { AppTimeline } from '@/animations/App.timeline'
import Footer from '@/components/Footer'

export default {
	name: 'App',

	components: {
		Footer,
	},

	created() {
		AppTimeline.start()
	},
}
</script>
